"use client";

import React, {useState, useEffect} from 'react';
import { ArrowUpCircleIcon } from '@heroicons/react/24/solid';

const ScrollButton = () => {
  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);

    return () => {
      window.removeEventListener('scroll', toggleVisible);
    };
  }, []);

  return (
    <button className='z-40 fixed bottom-5 right-10 rounded-full uppercase leading-normal' 
      onClick={scrollToTop}
      style={{display: visible ? 'inline' : 'none'}}>
      <ArrowUpCircleIcon
        className='h-12 w-12 text-gray-800'
        
      />
    </button>
  );
};

export default ScrollButton;